import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

// const borderColor = '#000000'
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        // borderBottomColor: '#000000',
        fontFamily:'Helvetica-Bold',
        // borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
        fontSize: 9,
        marginTop: '5px'
    },
    collumn: {
        textIndent:'8px',
        textAlign: 'left',
        // borderRightWidth: 1,
        fontFamily:'Helvetica-Bold',
        // borderRightColor: borderColor
    }
  });

  const MovimentsTableHeader = () => (
    <View style={styles.container}>
        <Text style={{ ...styles.collumn, ...{width:'7%'} } }>Vencimento</Text>
        <Text style={{ ...styles.collumn, ...{width:'7%'} }}>Pagamento</Text>
        <Text style={{ ...styles.collumn, ...{width:'7%'} }}>Documento</Text>
        <Text style={{ ...styles.collumn, ...{width:'12%'} }}>Cliente/Fornecedor</Text>
        <Text style={{ ...styles.collumn, ...{width:'21%'} }}>Histórico</Text>
        <Text style={{ ...styles.collumn, ...{width:'10%'} }}>Conta bancária</Text>
        <Text style={{ ...styles.collumn, ...{width:'10%'} }}>Plano de contas</Text>
        <Text style={{ ...styles.collumn, ...{width:'10%'} }}>Centro de custo</Text>
        <Text style={{ ...styles.collumn, ...{width:'7%'} }}>Valor (R$)</Text>
        <Text style={{ ...styles.collumn, ...{width:'9%'} }}>Saldo (R$)</Text>
    </View>
  );
  
  export default MovimentsTableHeader